// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * One device of an OPC UA domain: the node id prefix and the item names
 * under it (`ns=2;s=<node_prefix>.<item>`).
 */
export class SimulationOpcUaDevice implements flatbuffers.IUnpackableObject<SimulationOpcUaDeviceT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationOpcUaDevice {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationOpcUaDevice(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaDevice,
  ): SimulationOpcUaDevice {
    return (obj || new SimulationOpcUaDevice()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationOpcUaDevice(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationOpcUaDevice,
  ): SimulationOpcUaDevice {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationOpcUaDevice()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * The device `longname`, e.g. `Dulles.Terminal_E.2033.2033`.
   */
  nodePrefix(): string;
  nodePrefix(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  nodePrefix(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  /**
   * The group `longname` the device belongs to, e.g. `Dulles.Terminal_E.2033`.
   */
  group(): string | null;
  group(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  group(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The KMP server name the group sits under, e.g. `KIC3`.
   */
  server(): string | null;
  server(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  server(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  items(index: number): string;
  items(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  items(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  itemsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationOpcUaDevice(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addNodePrefix(builder: flatbuffers.Builder, nodePrefixOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodePrefixOffset, 0);
  }

  static addGroup(builder: flatbuffers.Builder, groupOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, groupOffset, 0);
  }

  static addServer(builder: flatbuffers.Builder, serverOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, serverOffset, 0);
  }

  static addItems(builder: flatbuffers.Builder, itemsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, itemsOffset, 0);
  }

  static createItemsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startItemsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationOpcUaDevice(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_prefix
    return offset;
  }

  static createSimulationOpcUaDevice(
    builder: flatbuffers.Builder,
    nodePrefixOffset: flatbuffers.Offset,
    groupOffset: flatbuffers.Offset,
    serverOffset: flatbuffers.Offset,
    itemsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationOpcUaDevice.startSimulationOpcUaDevice(builder);
    SimulationOpcUaDevice.addNodePrefix(builder, nodePrefixOffset);
    SimulationOpcUaDevice.addGroup(builder, groupOffset);
    SimulationOpcUaDevice.addServer(builder, serverOffset);
    SimulationOpcUaDevice.addItems(builder, itemsOffset);
    return SimulationOpcUaDevice.endSimulationOpcUaDevice(builder);
  }

  unpack(): SimulationOpcUaDeviceT {
    return new SimulationOpcUaDeviceT(
      this.nodePrefix(),
      this.group(),
      this.server(),
      this.bb!.createScalarList<string>(this.items.bind(this), this.itemsLength()),
    );
  }

  unpackTo(_o: SimulationOpcUaDeviceT): void {
    _o.nodePrefix = this.nodePrefix();
    _o.group = this.group();
    _o.server = this.server();
    _o.items = this.bb!.createScalarList<string>(this.items.bind(this), this.itemsLength());
  }

  unpackFields(...fields: string[]): SimulationOpcUaDeviceT {
    const t = new SimulationOpcUaDeviceT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_prefix")) {
      t.nodePrefix = this.nodePrefix();
    }
    if (fieldSet.has("group")) {
      t.group = this.group();
    }
    if (fieldSet.has("server")) {
      t.server = this.server();
    }
    if (fieldSet.has("items")) {
      t.items = this.bb!.createScalarList<string>(this.items.bind(this), this.itemsLength());
    }
    return t;
  }
}

export class SimulationOpcUaDeviceT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodePrefix: string | Uint8Array | null = null,
    public group: string | Uint8Array | null = null,
    public server: string | Uint8Array | null = null,
    public items: string[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodePrefix === null || this.nodePrefix === undefined) {
      throw new Error('Required field "node_prefix" is not set');
    }
    const nodePrefix = this.nodePrefix !== null ? builder.createString(this.nodePrefix!) : 0;
    const group = this.group !== null ? builder.createString(this.group!) : 0;
    const server = this.server !== null ? builder.createString(this.server!) : 0;
    const items = SimulationOpcUaDevice.createItemsVector(
      builder,
      builder.createObjectOffsetList(this.items),
    );

    return SimulationOpcUaDevice.createSimulationOpcUaDevice(
      builder,
      nodePrefix,
      group,
      server,
      items,
    );
  }

  clone(): SimulationOpcUaDeviceT {
    const obj = new SimulationOpcUaDeviceT();
    obj.nodePrefix = this.nodePrefix;
    obj.group = this.group;
    obj.server = this.server;
    obj.items = [...this.items];
    return obj;
  }

  equals(other: SimulationOpcUaDeviceT): boolean {
    if (this.nodePrefix !== other.nodePrefix) return false;
    if (this.group !== other.group) return false;
    if (this.server !== other.server) return false;
    if (this.items.length !== other.items.length) return false;
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i] !== other.items[i]) return false;
    }
    return true;
  }
}

export function verifySimulationOpcUaDevice(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_prefix");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
  } finally {
    verifier.popDepth();
  }
}
